import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { typedEmailMatches } from '@/lib/admin-lockout-guards';

export function TypedEmailConfirmation({
  email,
  value,
  onChange,
  id = 'typed-email-confirm',
}: {
  email: string;
  value: string;
  onChange: (value: string) => void;
  id?: string;
}) {
  return (
    <div className="space-y-2 pt-2 text-left">
      <Label htmlFor={id}>
        Type <span className="font-semibold">{email}</span> to confirm
      </Label>
      <Input
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoComplete="off"
        data-testid="typed-email-confirm"
      />
    </div>
  );
}

export { typedEmailMatches };
